import React from "react";
import { leaf } from "../../assets";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { urlFor } from "../../client";
import Loading from "../Loading/Loading";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";

const TreatCard = ({ data, setSingleTreat }) => {
  const navigate = useNavigate();


  return (
    <>
      {data ? (
        <motion.div
          whileInView={{ y: [50, 0], opacity: [0, 1] }}
          transition={{ duration: 0.7 }}
          className="treatmentCard"
        >
          <div className="left">
            <LazyLoadImage effect="blur" src={urlFor(data.tretment_name)} alt="" className="treatBanner"/>
          </div>
          <div className="right">
            <img src={leaf} alt="" className="leaf" />
            <h2>{data.type}</h2>
            <h1>{data.title}</h1>
            <p className="desc">{data.shortDesc}</p>

            <div className="btn-grp">
              <button
                className="highLight firstHigh"
                onClick={() => navigate("/appointment")}
              >
                <p>Book Appointment</p>
              </button>

              <button className="highLight">
                <Link
                  className="linkBtn"
                  to="/treatment"
                  onClick={() => setSingleTreat(data)}
                >
                  <AiOutlineUnorderedList className="io" />
                  <p>See Details</p>
                </Link>
              </button>
            </div>
          </div>
        </motion.div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default TreatCard;
